/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Maintains the visibility state of the View Component.
 *
 */
export interface SplitViewState {
  hidden?: boolean;
}
